import React from 'react';
import { Spinner } from '@honeycomb-npm/honeycomb-react';
import './Loader.scss';

const Loader = () => (
  <div className="loader">
    <Spinner
      ariaLive="polite"
      isVisible
      screenreaderText="Loading. Please wait."
    />
  </div>
);

export default Loader;
